// extracted by mini-css-extract-plugin
export default {"text_container":"reset-password-page_text_container__Sdtkb","button_reset":"reset-password-page_button_reset__5cGkd"};